module.exports = __webpack_public_path__ + "img/coffee_bg.439760bf.png";